import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
  tag?: string;
}

export function PageHeader({ title, subtitle, action, className, tag }: PageHeaderProps) {
  return (
    <div className={cn('mb-8', className)}>
      {tag && (
        <p className="font-mono text-xs uppercase tracking-widest text-secondary mb-2">
          {tag}
        </p>
      )}
      <div className="flex justify-between items-end gap-4">
        <div>
          <h1 className="font-condensed text-5xl lg:text-6xl uppercase tracking-tight text-text-bright leading-[0.95]">
            {title}
          </h1>
          {subtitle && (
            <p className="text-text-muted mt-3 font-mono text-sm uppercase tracking-wider">
              {subtitle}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      <div className="h-1 bg-primary mt-4 w-24 shadow-[0_0_12px_0_rgba(255,138,101,0.6)]" />
    </div>
  );
}
